import {
  Calendar,
  DatePicker,
  DateField as HeroUIDateField,
} from '@heroui/react';
import { type CalendarDate, parseDate } from '@internationalized/date';

// 字符串日期封装:外层 state / API 参数保持 'YYYY-MM-DD' 字符串,组件边界转 CalendarDate
export function DateField({
  value,
  onChange,
  className,
  isDisabled,
  'aria-label': ariaLabel,
}: {
  value: string | null;
  onChange: (value: string | null) => void;
  className?: string;
  isDisabled?: boolean;
  'aria-label'?: string;
}) {
  // 字符串 → CalendarDate;非法值按空处理
  let dateValue: CalendarDate | null = null;
  if (value) {
    try {
      dateValue = parseDate(value.slice(0, 10));
    } catch {
      dateValue = null;
    }
  }
  return (
    <DatePicker
      aria-label={ariaLabel ?? '日期'}
      className={className}
      isDisabled={isDisabled}
      value={dateValue}
      onChange={(next) => onChange(next ? next.toString() : null)}
    >
      <HeroUIDateField.Group fullWidth>
        <HeroUIDateField.Input>
          {(segment) => <HeroUIDateField.Segment segment={segment} />}
        </HeroUIDateField.Input>
        <DatePicker.Trigger>
          <DatePicker.TriggerIndicator />
        </DatePicker.Trigger>
      </HeroUIDateField.Group>
      <DatePicker.Popover>
        <Calendar>
          <Calendar.Header>
            <Calendar.NavButton slot="previous" />
            <Calendar.Heading />
            <Calendar.NavButton slot="next" />
          </Calendar.Header>
          <Calendar.Grid>
            <Calendar.GridHeader>
              {(day) => <Calendar.HeaderCell>{day}</Calendar.HeaderCell>}
            </Calendar.GridHeader>
            <Calendar.GridBody>
              {(date) => (
                <Calendar.Cell date={date}>
                  {({ formattedDate }) => (
                    <>
                      {formattedDate}
                      <Calendar.CellIndicator />
                    </>
                  )}
                </Calendar.Cell>
              )}
            </Calendar.GridBody>
          </Calendar.Grid>
        </Calendar>
      </DatePicker.Popover>
    </DatePicker>
  );
}
